<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">Contents</h1>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_fore_r1.htm">Foreword</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_ack_r1.htm">Acknowledgments</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_p01_r1.htm">Part I. Ghosts of Spring</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_p02_r1.htm">Part II. Ghosts of Summer</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_p03_r1.htm">Part III. Ghosts of Autumn</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_p04_r1.htm">Part IV. Ghosts of Winter</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_app_r1.htm">Suggested Reading</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_app1_r1.htm">Ghostly Places to Visit</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780813173894_epub_ata_r1.htm">About the Authors</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813173894_epub_toc_r1.vue?57fa4668